<template>
  <ux-form ref="form" :data="formData" :rules="rules">
    <ux-form-item :label="$t('HT.productAll.type')" prop="name">
      <el-input v-model="formData.name"></el-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  name: 'addProductType',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: ''
        };
      }
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addProductType()
    };
  }
};
</script>
